import ErrorIcon from '@mui/icons-material/Error';
import Typography from '@mui/material/Typography';

import { EXPIRED_CARD_WARNING } from 'reservations/payments/constants';

interface Props {
  isExpirationValid: boolean;
}

export const ExpiredPayment = ({ isExpirationValid }: Props) =>
  isExpirationValid ? null : (
    <>
      <Typography
        marginLeft="10px"
        fontSize="13px"
        sx={theme => ({
          color: theme.palette.error.main
        })}
      >
        {EXPIRED_CARD_WARNING}
      </Typography>
      <ErrorIcon color="error" />
    </>
  );
